<template>
  <NuxtLink
    :to="to"
    class="-mx-3 flex font-semibold gap-x-6 group hover:bg-base-200 items-center p-3 rounded-lg text-base-content text-base/7"
    @click="handleClick"
  >
    <div
      class="bg-base-200 flex flex-none group-hover:bg-base-100 items-center justify-center rounded-lg size-10"
    >
      <component
        :is="icon"
        class="group-hover:text-primary size-5 text-base-content/70"
        aria-hidden="true"
      />
    </div>
    {{ label }}
  </NuxtLink>
</template>

<script setup lang="ts">
import type { AnchorHTMLAttributes, Component } from 'vue'

const props = defineProps<{
  /** Native click listener forwarded to the link. */
  onClick?: AnchorHTMLAttributes['onClick']
  /** Link destination. */
  to: string
  /** Visible link text. */
  label: string
  /** Leading icon component. */
  icon: Component
}>()

const handleClick: NonNullable<AnchorHTMLAttributes['onClick']> = (event) => props.onClick?.(event)
</script>
